package api.data.request

import api.data.DataProperty
import dev.gitlive.firebase.firestore.FieldValue
import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class DataUpdateProperty(
//    @SerialName("id")
    var id: String = "",

//    @SerialName("title")
    var title: String = "",

//    @SerialName("location")
    var location: String = "",

//    @SerialName("size")
    var size: Double = 0.0,

//    @SerialName("bedrooms")
    var bedrooms: Int = 0,

//    @SerialName("bathrooms")
    var bathrooms: Int = 0,

//    @SerialName("description")
    var description: String = "",

//    @SerialName("type")
    var type: String = "",

//    @SerialName("price")
    var price: Int = 0,

//    @SerialName("currency")
    var currency: String = "",

//    @SerialName("amenities")
    var amenities: ArrayList<String> = ArrayList<String>(),

//    @SerialName("features")
    var features: ArrayList<String> = ArrayList<String>(),

//    @SerialName("yearBuilt")
    var yearBuilt: Int = 0,

//    @SerialName("images")
    var images: ArrayList<String> = ArrayList<String>(),

    @SerialName("ownerFirstName")
    var ownerFirstName: String = "",

    @SerialName("ownerLastName")
    var ownerLastName: String = "",

//    @SerialName("ownerEmail")
    var ownerEmail: String = "",

//    @SerialName("ownerPhone")
    var ownerPhone: String = "",

//    @SerialName("purpose")
    var purpose: String = "",

//    @SerialName("status")
    var status: String = "",

//    @SerialName("isApproved")
    var isApproved: Boolean = false,

//    @SerialName("rejectedBy")
    var rejectedBy: String = "",

//    @SerialName("rejectionReason")
    var rejectionReason: String = "",

//    @SerialName("approvedBy")
    var approvedBy: String = "",

//    @SerialName("approvedOn")
    var approvedOn: Timestamp = Timestamp.now(),

//    @SerialName("createdOn")
    var createdOn: Timestamp = Timestamp.now(),

//    @SerialName("updatedOn")
    var updatedOn: Timestamp = Timestamp.now(),

    var submittedBy: String = "",

    var rentBillFrequency: String = "",
)


fun DataUpdateProperty.toHashMap(): HashMap<String, Any?> {
    return hashMapOf(
        "id" to id,
        "title" to title,
        "location" to location,
        "size" to size,
        "bedrooms" to bedrooms,
        "bathrooms" to bathrooms,
        "description" to description,
        "type" to type,
        "price" to price,
        "currency" to currency,
        "amenities" to amenities,
        "features" to features,
        "yearBuilt" to yearBuilt,
        "images" to images,
        "ownerEmail" to ownerEmail,
        "ownerPhone" to ownerPhone,
        "ownerFirstName" to ownerFirstName,
        "ownerLastName" to ownerLastName,
        "purpose" to purpose,
        "status" to "Active",
        "isApproved" to isApproved,
        "rejectedBy" to rejectedBy,
        "rejectionReason" to rejectionReason,
        "approvedBy" to approvedBy,
        "approvedOn" to FieldValue.serverTimestamp,
        "createdOn" to FieldValue.serverTimestamp,
        "updatedOn" to FieldValue.serverTimestamp,
        "submittedBy" to submittedBy,
        "rentBillFrequency" to rentBillFrequency
    )
}